import { defineMessages } from 'react-intl'

export default defineMessages({
  warning: {
    id: 'soundnew.message.reject',
    defaultMessage:
      'Not supported format [ {filenames} ]. Please select audio file.',
  },
  selectFiles: {
    id: 'soundnew.selectfiles',
    defaultMessage: 'Please select files...',
  },
  makeAlbum: {
    id: 'soundnew.makealbum',
    defaultMessage: 'Make a album when multiple files are selected',
  },
  addAlbum: {
    id: 'soundnew.album.add',
    defaultMessage: 'Make a album',
  },
  albumTitlePlaceholder: {
    id: 'soundnew.album.title.placeholder',
    defaultMessage: 'Album Title',
  },
  albumDescriptionLabel: {
    id: 'soundnew.album.descr.label',
    defaultMessage: 'Album this album',
  },
  albumDescriptionPlaceholder: {
    id: 'soundnew.album.descr.placeholder',
    defaultMessage: 'Add description here...',
  },
  mediaOptionLess: {
    id: 'soundnew.media.option.less',
    defaultMessage: 'Save',
  },
  mediaOptionMore: {
    id: 'soundnew.media.option.more',
    defaultMessage: 'Edit',
  },
  mediaLimitLabel: {
    id: 'soundnew.media.limit.label',
    defaultMessage: 'Limit the streaming time',
  },
  mediaLimitLabelWait: {
    id: 'soundnew.media.limit.wait',
    defaultMessage: 'Please wait until transcode will be done.',
  },
  mediaLimitTime: {
    id: 'soundnew.media.limit.time',
    defaultMessage: 'Times',
  },
  mediaLimitPlay: {
    id: 'soundnew.media.limit.play',
    defaultMessage: 'Play Sample',
  },
  mediaAboutTitle: {
    id: 'soundnew.media.about.title',
    defaultMessage: 'About this sound',
  },
  mediaLyricsTitle: {
    id: 'soundnew.media.lyrics.title',
    defaultMessage: 'Lyrics',
  },
  mediaAboutPlaceholder: {
    id: 'soundnew.media.about.placeholder',
    defaultMessage: 'Add description here...',
  },
  mediaLyricsPlaceholder: {
    id: 'soundnew.media.lyrics.placeholder',
    defaultMessage: 'Add Lyrics here...',
  },
  mediaSellSound: {
    id: 'soundnew.media.sound.sell',
    defaultMessage: 'Make this sound on Sale',
  },
  mediaSellAlbum: {
    id: 'soundnew.media.album.sell',
    defaultMessage: 'Make this Album on Sale',
  },
  mediaPriceLabel: {
    id: 'soundnew.media.price.label',
    defaultMessage: 'Price',
  },
  mediaPriceMore: {
    id: 'soundnew.media.price.more',
    defaultMessage: 'or more',
  },
  saveAndPubishP: {
    id: 'soundnew.save.p',
    defaultMessage: 'Click button to save and publish sounds!',
  },
  saveAndPubishB: {
    id: 'soundnew.save.b',
    defaultMessage: 'Save and Publish',
  },
  saveAndPubishing: {
    id: 'soundnew.save.ing',
    defaultMessage: 'Save and Publishing...',
  },
  waitSaving: {
    id: 'soundnew.save.wait',
    defaultMessage: 'Please wait until sounds ready...',
  },
  uploadError: {
    id: 'soundnew.message.error',
    defaultMessage: 'Failed to save sounds. Please try again later...',
  },
  uploadSuccess: {
    id: 'soundnew.message.success',
    defaultMessage: 'Congratulation 🎉  \nYour sounds successfuly published.',
  },
  albumSaved: {
    id: 'album.edit.saved',
    defaultMessage: 'Your album successfuly updated. 🎉 ',
  },
  soundSaved: {
    id: 'sound.edit.saved',
    defaultMessage: 'Your sound successfuly updated. 🎉 ',
  },
  albumSaveError: {
    id: 'album.edit.error',
    defaultMessage: 'Error occurred, please try again, later.',
  },
  soundSaveError: {
    id: 'sound.edit.error',
    defaultMessage: 'Error occurred, please try again, later.',
  },
})
